import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class Badge extends Component {

    static propTypes = {
        color: PropTypes.string,
        value: PropTypes.number,
        hoverText: PropTypes.string
    };
    render() {
        return(
            <span title={this.props.hoverText} className={'badge badge-pill badge-' + this.props.color}>{this.props.value}</span>
        )
    }
}



// WEBPACK FOOTER //
// ./React/src/components/EngineInfo/Badge.js